// extracted by mini-css-extract-plugin
export default {"p_tye":"_84e6ad5add","slcted":"c76d6b2b5f","slc_color":"_47f7234b55","item_p":"_7648586ca1","r0":"e5f7cde027"};